// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  padding: 0.5rem 0;
}

h3, h4 {
  margin: 0.5rem 0 0.25rem;
}

.job-breadcrumb-title {
  font-family: "GothamNarrowBook", Arial, sans-serif;
  font-weight: normal;
}

.job-breadcrumb-link {
  font-family: "GothamNarrowBold", Arial, sans-serif;
  font-weight: normal;
  cursor: pointer;
}

.section-title {
  margin: 0.5rem 0 0.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #555;
}

.content {
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 4px;
}

.job-info-block .job-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  gap: 10px 28px;
}
.job-info-block .job-info-item {
  display: grid;
  grid-template-columns: 130px 1fr;
  align-items: center;
  column-gap: 10px;
}
.job-info-block .job-info-bottom-row {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px;
}
.job-info-block .job-info-job-column {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.job-info-block .job-info-job-column .job-info-item {
  grid-template-columns: max-content 1fr;
  column-gap: 8px;
}
.job-info-block .job-info-label {
  font-size: 1rem;
  font-family: "GothamNarrowBold", Arial, sans-serif;
  color: #111;
  margin: 0;
}
.job-info-block .job-info-value {
  font-size: 1rem;
  line-height: 1.3;
  color: #555;
  background-color: #ededee;
  border-radius: 4px;
  padding: 4px 10px;
  min-height: 30px;
  display: flex;
  align-items: center;
}
@media (max-width: 991.98px) {
  .job-info-block .job-info-grid {
    grid-template-columns: 1fr;
  }
  .job-info-block .job-info-item {
    grid-template-columns: 120px 1fr;
  }
  .job-info-block .job-info-bottom-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .job-info-block .job-info-job-column {
    grid-template-columns: 1fr;
  }
}

.tile {
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 1rem;
  cursor: pointer;
}
.tile:hover {
  background-color: #f5f5f5;
}

:host ::ng-deep .nextpage-tabs .mdc-tab__text-label {
  font-size: 1.4rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-details.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,kDAAA;EACA,mBAAA;AACF;;AAEA;EACE,kDAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAGE;EACE,aAAA;EACA,oDAAA;EACA,cAAA;AAAJ;AAGE;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAIE;EACE,iBAAA;EACA,aAAA;EACA,gDAAA;EACA,SAAA;AAFJ;AAKE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAHJ;AAKI;EACE,sCAAA;EACA,eAAA;AAHN;AAOE;EACE,eAAA;EACA,kDAAA;EACA,WAAA;EACA,SAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AANJ;AASE;EACE;IACE,0BAAA;EAPJ;EAUE;IACE,gCAAA;EARJ;EAWE;IACE,0BAAA;IACA,SAAA;EATJ;EAYE;IACE,0BAAA;EAVJ;AACF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAXF;AAaE;EACE,yBAAA;AAXJ;;AAeA;EACE,iBAAA;AAZF","sourcesContent":[":host {\n  display: block;\n  padding: 0.5rem 0;\n}\n\nh3, h4 {\n  margin: 0.5rem 0 0.25rem;\n}\n\n.job-breadcrumb-title {\n  font-family: \"GothamNarrowBook\", Arial, sans-serif;\n  font-weight: normal;\n}\n\n.job-breadcrumb-link {\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n  font-weight: normal;\n  cursor: pointer;\n}\n\n.section-title {\n  margin: 0.5rem 0 0.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #555;\n}\n\n.content {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 4px;\n}\n\n.job-info-block {\n  .job-info-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(320px, 1fr));\n    gap: 10px 28px;\n  }\n\n  .job-info-item {\n    display: grid;\n    grid-template-columns: 130px 1fr;\n    align-items: center;\n    column-gap: 10px;\n  }\n\n  .job-info-bottom-row {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 28px;\n  }\n\n  .job-info-job-column {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n\n    .job-info-item {\n      grid-template-columns: max-content 1fr;\n      column-gap: 8px;\n    }\n  }\n\n  .job-info-label {\n    font-size: 1rem;\n    font-family: \"GothamNarrowBold\", Arial, sans-serif;\n    color: #111;\n    margin: 0;\n  }\n\n  .job-info-value {\n    font-size: 1rem;\n    line-height: 1.3;\n    color: #555;\n    background-color: #ededee;\n    border-radius: 4px;\n    padding: 4px 10px;\n    min-height: 30px;\n    display: flex;\n    align-items: center;\n  }\n\n  @media (max-width: 991.98px) {\n    .job-info-grid {\n      grid-template-columns: 1fr;\n    }\n\n    .job-info-item {\n      grid-template-columns: 120px 1fr;\n    }\n\n    .job-info-bottom-row {\n      grid-template-columns: 1fr;\n      gap: 10px;\n    }\n\n    .job-info-job-column {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.tile {\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #f5f5f5;\n  }\n}\n\n:host ::ng-deep .nextpage-tabs .mdc-tab__text-label {\n  font-size: 1.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
